import React from 'react'
import styled, { CSSObject } from '@emotion/styled'

interface AnimatedRowProps {
  shouldShow: boolean
  maxHeight?: string
  additionalStyles?: CSSObject
  testId?: string
  children: React.ReactNode
}

/** Reusable Wrapper component that provides smooth expand/collapse animations using maxHeight transitions
 * maxHeight should be set high enough to accommodate expected content for smooth CSS animations */
const AnimatedRow: React.FC<AnimatedRowProps> = ({
  shouldShow,
  maxHeight = '100px',
  additionalStyles,
  testId,
  children
}) => {
  return (
    <StyledAnimatedRow
      shouldShow={shouldShow}
      maxHeight={maxHeight}
      additionalStyles={additionalStyles}
      data-testid={testId}
    >
      {children}
    </StyledAnimatedRow>
  )
}

const StyledAnimatedRow = styled.div<{
  shouldShow: boolean
  maxHeight: string
  additionalStyles?: CSSObject
}>(({ shouldShow, maxHeight, additionalStyles }) => ({
  maxHeight: shouldShow ? maxHeight : '0px',
  opacity: shouldShow ? 1 : 0,
  transition: 'max-height 300ms ease-in-out, opacity 300ms ease-in-out',
  overflow: 'hidden',
  ...additionalStyles
}))

export default AnimatedRow
